import { render, staticRenderFns } from "./ModalResetGrade.vue?vue&type=template&id=2b134355&"
import script from "./ModalResetGrade.vue?vue&type=script&lang=js&"
export * from "./ModalResetGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports